<template>
  <div :class="!disable ? 'disable-events' : ''">
    <v-row>
      <v-col>
        <div v-for="(item, index) in timeRestrictions" :key="item.id">
          <v-row>
            <v-col lg="4" md="6" sm="12">
              <span class="text-capitalize text-body-2 tertiary--text">
                {{
                  $t(
                    'fleet_management.agents.create.labels.create_days_aplication'
                  )
                }}
              </span>
              <days
                :id="item.id"
                :domElementIdProp="index"
                :idRestrictions="item.id"
                :edit="item.days"
                :disable="disable"
                @timeDays="daysEmit"
              ></days
            ></v-col>
            <v-col offset-lg="-3" lg="5" md="6" sm="12" xs="12">
              <div>
                <span class="text-capitalize text-body-2 tertiary--text">
                  {{
                    $t(
                      'fleet_management.agents.create.labels.create_range_hours'
                    )
                  }}
                </span>
              </div>
              <time-range
                :indexForDomElementIds="index"
                @emitValidRange="emitValidRange"
                :disable="disable"
                :idRestrictions="item.id"
                :edit="item.hours"
                @hoursRange="timeRangeHours"
              />
            </v-col>
          </v-row>
          <v-row class="pr-3">
            <v-col
              cols="12"
              lg="12"
              md="12"
              sm="12"
              xl="12"
              class="d-flex justify-end align-end"
            >
              <FmButton
                :id="`idEventosEliminarRestriccionHoraria${index}`"
                v-if="disable"
                @click="removeRestriction(item.id)"
                :button-text="'Eliminar'"
                :type="'close'"
              />
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <FmButton
          :id="'idEventosAgregarRestriccionHoraria'"
          v-if="disable"
          :color="'tertiary'"
          @click="addRestriction()"
          :button-text="
            $t('fleet_management.agents.create.labels.create_restriction_time')
          "
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div class="divider-dotted"></div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import days from './days.vue'
import { firebaseServices } from '@leapsight/styleguide'
import { FirebaseTagNames } from '@leapsight/portal'
import timeRange from './timeRange.vue'
import { AgentsHelpers } from '@/helpers/mainExports.js'
import { mapMutations } from 'vuex'
import FmButton from '@/share/components/FmButton.vue'
export default {
  components: {
    FmButton,
    days,
    timeRange
  },
  props: {
    restrictionCron: {
      type: Array,
      default: []
    },
    disable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      zonaHoraria: null,
      items: [
        {
          label: 'Chile, Santiago',
          value: 'America/Santiago',
          id: 'cl'
        },
        {
          label: 'Argentina, Buenos Aires',
          value: 'America/Buenos_Aires',
          id: 'ar'
        },
        {
          label: 'Uruguay, Montevideo',
          value: 'America/Montevideo',
          id: 'ur'
        }
      ],
      restriction: {
        days: [],
        hours: [],
        id: null
      },
      timeRestrictions: [],
      index: 0,
      cron_spec_selecction: [{ id: null }],
      scheduling: {
        cron_spec: ['* * * * *'],
        timezone: null
      },
      cronJob: [],
      validRange: true,
      validDay: true
    }
  },
  methods: {
    ...mapMutations(['validationsTimeRestriction']),
    isLenghtRestriction() {
      this.validDay = true
      this.validRange = true
      this.emitValid()
    },
    emitValid() {
      this.validationsTimeRestriction(this.validRange && this.validDay)
    },
    emitValidRange(e) {
      this.validRange = e
      this.emitValid()
    },
    timeRangeHours(time) {
      this.timeRestrictions.map(e => {
        if (e.id == time.id) {
          e.hours = time.range
        }
      })
      this.cronJob = []
    },
    formatCronSpec() {
      this.cronJob = []
      if (this.timeRestrictions) {
        this.timeRestrictions.map((restriction, index) => {
          this.formatCronJob(restriction, index)
        })
        if (this.cronJob) {
          this.scheduling.cron_spec = this.cronJob
          this.$emit('schedulingEmit', this.scheduling)
        }
      }
    },
    async formatCronJob(restriction, index) {
      const cron = await AgentsHelpers.getFormatDateToCron(
        restriction,
        this.cronJob,
        index
      )
      this.cronJob = cron
    },
    addRestriction() {
      firebaseServices.logEvent(
        firebaseServices.analytics,
        FirebaseTagNames.BTN_FLEET_MANAGEMENT_AGENT_ADD_RESTRICTION
      )

      const uniq = 'idRestriction' + new Date().getTime()
      const newRestriction = JSON.parse(JSON.stringify(this.restriction))
      newRestriction.id = uniq
      this.timeRestrictions.push(newRestriction)
    },
    removeRestriction(id) {
      this.timeRestrictions = this.timeRestrictions.filter(e => e.id != id)
      this.formatCronSpec()
      this.validRange = true
      this.emitValid()
      this.validationsDays()
    },
    daysEmit(days) {
      this.timeRestrictions.map(e => {
        if (e.id == days.id) {
          e.days = days.days
        }
      })
      this.validationsDays()
    },
    validationsDays() {
      const validDays = this.timeRestrictions.every(day => day.days.length > 0)

      if (validDays) {
        this.validDay = true
        this.emitValid()
      } else {
        this.validDay = false
        this.emitValid()
      }
    },
    searchLocation() {
      const country = localStorage.getItem('country_id')
      switch (country) {
        case 'ar':
          this.scheduling.timezone = 'America/Buenos_Aires'
          break
        case 'cl':
          this.scheduling.timezone = 'America/Santiago'
          break
        case 'uy':
          this.scheduling.timezone = 'America/Montevideo'
          break
      }
    }
  },
  watch: {
    timeRestrictions: {
      handler(val) {
        this.formatCronSpec()
      },
      deep: true
    },
    restrictionCron: {
      handler(val) {
        this.timeRestrictions = val
      },
      deep: true
    },

    disable: function() {}
  },
  mounted() {
    this.emitValid()
    this.searchLocation()
    if (this.disable === false) this.timeRestrictions = this.restrictionCron
  }
}
</script>

<style></style>
